'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationEventNote = function NotificationEventNote(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z' })
  );
};
NotificationEventNote = (0, _pure2.default)(NotificationEventNote);
NotificationEventNote.displayName = 'NotificationEventNote';
NotificationEventNote.muiName = 'SvgIcon';

exports.default = NotificationEventNote;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/notification/event-note.js
// module id = 1611
// module chunks = 1